import { FC } from 'react';

import { SentenceContainer } from '@custom-components/InspirationAdviceFilter';
import { useTranslation } from '@i18n';
import { useContent } from '@sitecore/common';
import type { InspirationAdviceFilterRendering } from '@sitecore/types/InspirationAdviceFilter';
import { Box, Stack } from '@sparky';

import { useFilter } from '../../InspirationAdviceFilter.context';
import { getFiltersFromSessionStorage } from '../../utils/filtersInSessionStorage';
import { FilterPhrase } from '../FilterPhrase/FilterPhrase';

export const FilterSentence: FC = () => {
  const { t } = useTranslation();
  const {
    fields: { phrasesList },
  } = useContent<InspirationAdviceFilterRendering>();
  const { filterTags, setFilterTags, setFilterIsManuallyChanged } = useFilter();

  const setFilterPhraseValue = (key: string, value: string) => {
    setFilterIsManuallyChanged(true);

    if (value === '') {
      delete filterTags[key];
      return setFilterTags({ ...filterTags });
    }

    setFilterTags(prevState => ({ ...prevState, [key]: value }));
  };

  return (
    <Box paddingBottom={{ initial: '10', lg: '12' }} paddingTop={{ initial: '10', lg: '12' }}>
      <SentenceContainer gap={{ initial: '3', md: '6' }}>
        <Stack.Item>
          <Stack alignY="center" alignX="start" direction={{ initial: 'row' }} gap="3" wrap>
            {phrasesList.map(value => {
              if (!value.fields.tagsList) return null;

              return (
                <Stack.Item key={value.id}>
                  <FilterPhrase
                    alignX="start"
                    alignY="center"
                    direction={{ initial: 'row' }}
                    gap={{ initial: '1', lg: '3' }}
                    label=""
                    name={value.name}
                    onChange={event => setFilterPhraseValue(event.target.name, event.target.value)}
                    options={value.fields.tagsList.reduce(
                      (acc, tag) => {
                        acc.push({
                          label: tag.fields.text?.value ?? tag.displayName,
                          value: tag.name,
                        });
                        return acc;
                      },
                      [
                        {
                          label: '',
                          value: '',
                        },
                      ],
                    )}
                    value={getFiltersFromSessionStorage(value.name) ?? ''}
                    placeholder=""
                    start={t(`filterSentence.${value.name}.label.start`)}
                    end={t(`filterSentence.${value.name}.label.end`)}
                    ariaLabel={t(`filterSentence.${value.name}.label.ariaLabel`)}
                  />
                </Stack.Item>
              );
            })}
          </Stack>
        </Stack.Item>
      </SentenceContainer>
    </Box>
  );
};
